export default {

    // 会社管理「追加オプション」の各ラジオボタンに設定するlabel
    CallRecordingOptionLabel : "通話録音",
    IvrOptionLabel : "IVR",
    IvrTranslateOptionLabel : "多言語翻訳機能",
    CallAnalysisOptionLabel : "通話品質分析",
    CallAnalysisApiOptionLabel : "┗ 通話品質分析API",
    CallAutoTagOptionLabel: "通話分類タグ",
    CallEvalOptionLabel: "応対品質分析",
    AcdOptionLabel : "ACD機能",
    OptionLabelTree : "┗ ",
    CallResultOptionLabel : "コール結果",
    AutoReceptionOptionLabel : "自動受電",

    // cm98.memo設定値
    CallRecordingOptionAllowed : "通話録音オプション許可",
    IvrOptionAllowed : "IVRオプション許可",
    IvrTranslateOptionAllowed : "IVR多言語翻訳オプション許可",
    CallAnalysisOptionAllowed : "通話品質分析オプション許可",
    CallAnalysisApiOptionAllowed : "通話品質分析APIオプション設定",
    CallAutoTagOptionAllowed: "通話分類オプション許可",
    CallEvalOptionAllowed: "応対品質分析オプション許可",
    AcdOptionAllowed : "ACD機能オプション許可",
    CallResultOptionAllowed : "コール結果・ランク許可",
    AutoReceptionOptionAllowed : "自動受電オプション許可",
    ShowAddingConfirmationPopupAllowed: "対象の画面でのデータ変更時、追加確認ポップアップを表示する",
    SendMailWhenDataIsChangedAllowed: "対象の画面でのデータ変更時、会社管理画面で指定された宛先へメールを送信する",
    SendMailAddressToWhenDataIsChanged: "データ変更時通知メール宛先",
    SendMailAddressCcWhenDataIsChanged: "データ変更時通知メールCc",
    SendMailAddressBccWhenDataIsChanged: "データ変更時通知メールBcc",

    call_analysis_api_select: [
        { value: "ascend_whisper", label: "Ascend Whisper"}
    ],

    // 会社管理「追加オプション」の説明
    CallRecordDescription: "通話履歴画面にて録音音声を\n再生・ダウンロードできるようになります。\nまた、オムニフォンの通話録音画面で\n録音音声を再生できるようになります。",
    IvrDescription: "営業時間管理画面の「挙動」項目に、\n自動応答音声（スクリプト）を設定できるようになります。",
    IvrTranslateDescription: "スクリプト管理画面の音声合成の種類で\n「音声合成（翻訳）」を選択できるようになります。",
    CallAnalysisDescription: "通話をテキスト化し、その内容を\n通話品質分析画面から確認できるようになります。",
    CallAnalysisApiDescription: "通話のテキスト化で使用するAPIを選択してください。\n※AscendWhisper推奨",
    CallAutoTagDescription: "通話分類画面にて設定したルールに基づいて、\n通話内容に応じて自動的にタグを付与できるようになります。",
    CallEvalDescription: "テキスト化された通話内容の分析を行い、\nその結果の詳細を通話履歴画面で確認できるようになります。",
    AcdDescription: "業務管理画面にて設定したルールに基づいて、\n着信をオペレーター管理にて作成されたオペレーターへ自動で振り分けることができるようになります。",
    CallResultDescription: "コール結果管理画面で登録したコール結果を、\n通話に登録できるようになります。\nまた、通話履歴画面より通話ごとに登録されたコール結果を確認できるようになります。\n※通話へのコール結果の登録は、オムニフォンforPC/プラグインの通話後に表示される画面、もしくは通話履歴画面から実施することができます。",
    AutoReceptionDescription: "営業時間管理画面の「挙動」項目に、\n自動受電を設定できるようになります。\n着信時にAIエージェントへ自動転送されます。"
}